import { render, staticRenderFns } from "./voluntariado-detalle.vue?vue&type=template&id=3cb3ee1b"
import script from "./voluntariado-detalle.vue?vue&type=script&lang=js"
export * from "./voluntariado-detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports